<template>
    <a-modal
            :title="actType"
            centered
            :width="520"
            :visible="showJumpJuliangPage"
            :confirmLoading="loading"
            @cancel="close"
            :footer="null"
    >
        
    <div style="min-height:200px;">
        <a-row type="flex" style="margin:20px">
            <a-col  flex="320px">
               当前巨量已登录邮箱
            </a-col>
            <a-col flex="auto">
                <a href="javascript:;"  @click="autoLoginJuliang()" >
                    进入账户
                </a>
            </a-col>
        </a-row>

        <a-row type="flex" v-for="(item,index) in model.emails" :key="index" style="margin:20px">
            <a-col  flex="320px">
                {{item.name}}
            </a-col>
            <a-col flex="auto">
                <a href="javascript:;"  @click="autoLoginJuliang(item.name, item.cookie)" >
                    进入账户
                </a>
            </a-col>
        </a-row>
    </div>
   

    </a-modal>
</template>

<style lang="less" scoped>
@import 'JumpJuliang';
</style>

<script>
import JumpJuliang from './JumpJuliang'

export default JumpJuliang
</script>
